import { ModelDetails } from "../configuration/model-description.ts";
import Item from "../models/item.ts";

function getItems(): Promise<Item[]> {
    const id = "1P8INzuS-y5KwBV3uMjDKyimbF1h3N5GezjqjeC-HV_0";
    const gid = "0";
    const url = "https://docs.google.com/spreadsheets/d/" + id + "/gviz/tq?tqx=out:json&tq&gid=" + gid

    return fetch(url)
        .then(res => res.text())
        .then((res) => {
            const result = JSON.parse(res.slice(47, -2));

            const items: Item[] = [];
            result.table.rows.forEach((row: { c: any[]; }) => {
                const itemId = row.c[0].v;
                const brand = row.c[17]?.v || "Levi’s";
                const model = row.c[1].v;
                const color: string = row.c[2].v;
                const waist = row.c[3].v;
                const length = row.c[4].v;
                const modelDetails = ModelDetails[model];
                const timestamp = new Date().getTime();
                const tag = row.c[17]?.v && 'Premium';
                const useDefaultImages = !row.c[13] && !row.c[14] && !row.c[15] && !row.c[16];

                const item: Item =
                {
                    id: itemId,
                    model: model,
                    name: `${brand} ${model} ${modelDetails.fitName} Fit`,
                    color: color,
                    waist: waist,
                    length: length,
                    composition: row.c[5].v,
                    halfWaistband: row.c[6]?.v,
                    rise: row.c[7]?.v,
                    seam: row.c[8]?.v,
                    legOpening: row.c[9]?.v,
                    price: row.c[10].v,
                    stockStatus: row.c[11]?.v == 0 ? 'outOfStock' :
                                 row.c[11]?.v == 1 ? 'inStock' :
                                 'awaiting',
                    olxUrl: row.c[12] ? `${row.c[12].v}?s=${waist}-${length}&t=${timestamp}` : null,
                    imageCatalog: row.c[13]?.v ||
                        (useDefaultImages ? `https://lsco.scene7.com/is/image/lsco/${itemId}-front-pdp?fmt=jpeg&qlt=70&resMode=bisharp&op_usm=0.6,0.6,8&fit=crop,0&wid=350&hei=350` : null),
                    imageFront: row.c[14]?.v ||
                        (useDefaultImages ? `https://lsco.scene7.com/is/image/lsco/${itemId}-front-pdp?fmt=jpeg&qlt=70&resMode=bisharp&op_usm=0.6,0.6,8&fit=crop,0&wid=700&hei=700` : null),
                    imageFrontMaxSize: row.c[14]?.v ||
                        (useDefaultImages ? `https://lsco.scene7.com/is/image/lsco/${itemId}-front-pdp?fmt=jpeg&qlt=70&resMode=bisharp&op_usm=0.6,0.6,8&fit=crop,0&wid=1200&hei=1200` : null),
                    imageBack: row.c[15]?.v ||
                        (useDefaultImages ? `https://lsco.scene7.com/is/image/lsco/${itemId}-back-pdp?fmt=jpeg&qlt=70&resMode=bisharp&op_usm=0.6,0.6,8&fit=crop,0&wid=700&hei=700` : null),
                    imageBackMaxSize: row.c[15]?.v ||
                        (useDefaultImages ? `https://lsco.scene7.com/is/image/lsco/${itemId}-back-pdp?fmt=jpeg&qlt=70&resMode=bisharp&op_usm=0.6,0.6,8&fit=crop,0&wid=1200&hei=1200` : null),
                    imageSide: row.c[16]?.v ||
                        (useDefaultImages ? `https://lsco.scene7.com/is/image/lsco/${itemId}-side-pdp?fmt=jpeg&qlt=70&resMode=bisharp&op_usm=0.6,0.6,8&fit=crop,0&wid=700&hei=700` : null),
                    imageSideMaxSize: row.c[16]?.v ||
                        (useDefaultImages ? `https://lsco.scene7.com/is/image/lsco/${itemId}-side-pdp?fmt=jpeg&qlt=70&resMode=bisharp&op_usm=0.6,0.6,8&fit=crop,0&wid=1200&hei=1200` : null),
                    tag: tag,
                    slug: `levis-${model}-${modelDetails.fitName}-${color}`.trim().toLowerCase().replace(/\s+/g, '-')
                };
                items.push(item);
            });

            return items;
        });
}

export default getItems;
